import { IconCar16, IconWalk16 } from '@cian/ui-kit/icons';
import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType } from '../../../../types/newbuildingPromoBuilderOffers';

interface IFromUndergroundProps {
  transportType: ETransportType;
  timeTo: string;
}

export function FromUndergroundTime({ transportType, timeTo }: IFromUndergroundProps) {
  const Icon = transportType === ETransportType.Walk ? IconWalk16 : IconCar16;

  return (
    <div className={styles['distance']} data-testid="from_underground_time">
      <div className={styles['icon']}>
        <Icon data-testid={`from_underground_time_icon_${transportType}`} color={'gray_icons_100'} />
      </div>
      <UIText2 color={'gray60_100'}>{timeTo}</UIText2>
    </div>
  );
}
